import "../../design/adsSection.css";
import { useEffect, useState } from "react";
import api from "../../api/API_SERVERS";

export default function AdsSection({ type }) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAds = async () => {
            try {
                const res = await api.get("/api/public/ads");
                const adsList = res.data[type] || [];

                // RULE 3: For the partner carousel, duplicate items if they are fewer than 8
                // to maintain an uninterrupted, seamless CSS infinite sliding track.
                if (type === "carousel" && adsList.length > 0 && adsList.length < 8) {
                    const duplicatedList = [...adsList, ...adsList, ...adsList];
                    setData(duplicatedList);
                } else {
                    setData(adsList);
                }
            } catch (e) {
                console.error("Failed loading advertisements:", e);
            } finally {
                setLoading(false);
            }
        };
        fetchAds();
    }, [type]);

    if (loading || data.length === 0) return null; // Hide area gracefully if no ads are running

    // 1. Separate render for Carousel (renders simple brand logos without description blocks)
    if (type === "carousel") {
        return (
            <div className="ads ads-carousel">
                <div className="slider-track">
                    {data.map((ad, index) => (
                        <div
                            key={`${ad.id || index}-${index}`}
                            className="carousel-slide"
                            onClick={() => window.open(ad.link || "https://example.com", "_blank")}
                        >
                            <img src={ad.image} alt={ad.title || "Partner Logo"} />
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    // 2. Normal render for Big, Medium, and Small banner placements
    return (
        <div className={`ads ads-${type}`}>
            {data.map((ad, index) => (
                <div key={ad.id || index} className={`ad-card ${type}`} onClick={() => {
                    window.open(ad.link ? ad.link : "https://example.com", "_blank");
                }}>
                    <span className="ad-badge">Sponsored</span>

                    <div className="ad-card-inner">
                        {ad.image && (
                            <div className="ad-img-wrapper">
                                <img src={ad.image} alt={ad.title || "Ad image"} />
                            </div>
                        )}
                        <div className="ad-content">
                            <h3>{ad.title || "რეკლამის სახელი"}</h3>
                            <p>{ad.text || "რეკლამის ტექსტი"}</p>
                        </div>
                    </div>

                    <div className="ad-btn-wrapper">
                        <div className="ad-btn">
                            {ad.link ? "ნახვა" : "რეკლამის ლინკი"}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}